// src/react/ErrorManagementError.ts
var ErrorManagementError = class extends Error {
  constructor(event) {
    if (event.exception instanceof Error) {
      super(event.exception.message, {
        cause: event.exception
      });
    } else {
      super(event.exception);
    }
    this.event = event;
  }
};
export { ErrorManagementError };